  function JudgemeInit() 
  {
    const images = document.querySelectorAll('.jdgm-carousel-item__product-image');
    if(images){
       
      images.forEach(img => {
        if(img.src != ''){
          img.src = img.src.replace("140x140","600x600");
        }else {
          img.onload = function() {
            img.src = img.src.replace("140x140","600x600");
          };
        }
      });
    }
  };

  function hiddenSearch(){
    // 设置轮询检查
    const checkInterval = setInterval(() => {
      const searchbox = document.querySelector('.snize-sticky-searchbox');
      
      if (searchbox) {
        clearInterval(checkInterval); // 停止循环
        searchbox.style.display = 'none';
      } 
    }, 100); 
  };

  
  const TPT_FORM_ACTIVE = 'active';
  const TPT_FORM_BACKGROUND = 'popup-background';
  
  function hiddenFormFloat(){
    // 设置轮询检查
    const checkInterval_form = setInterval(() => {
      const formFloat = document.querySelector('.floating-button');
      
      if (formFloat) {
        clearInterval(checkInterval_form); // 停止循环
        formFloat.classList.add('search-displaynone');
      } 
    }, 100); 

    const popupBtn = document.querySelector('.tpt-popup-nmkj');
    
    if(popupBtn){
      popupBtn.addEventListener('click', function() {
        const popupForm = document.querySelector('.globo-form-app');
        
        if (popupForm) {
          popupForm.classList.add(TPT_FORM_ACTIVE,TPT_FORM_BACKGROUND);
        }
      });
    }
  };

    
const CTL_REMOVE_CLASSNAME = 'pt_menu';
const CTL_REMOVE_CLASSNAME_MO = 'nav-4';
function ctlByYourDaddy(rootEl = document) {
  const ctlElements = Array.from(rootEl.getElementsByClassName('pt_menu_had_child'));
  
  if (ctlElements.length === 0) return;

        var datenow = new Date();
    
    let day = datenow.getDate() > 9 ? datenow.getDate():'0' + datenow.getDate();
    let month = datenow.getMonth() > 8 ? datenow.getMonth + 1 :'0' + (datenow.getMonth() + 1);
    let year = datenow.getFullYear();
    let end = `${year}-${month}-${day}`;
    let endline = '2025-11-20';
    if(end > endline) {
      ctlElements.forEach((element) => {
        element.classList.remove(CTL_REMOVE_CLASSNAME);
        element.classList.remove(CTL_REMOVE_CLASSNAME_MO);
      });
    }
  
  return;
};


function smartCartInit(){
  const cart_btn = document.getElementById('cart');
  const host = document.getElementById('upCart');

  // Guard: upCart web component may not be mounted yet on internal navigation
  if (!host || !host.shadowRoot) return;

  const shadowRoot = host.shadowRoot;
  
  if (cart_btn){
    const checkInterval_cart = setInterval(() => {
      const Upcart_Popup = shadowRoot.getElementById('UpcartPopup');
      const CartPopup = shadowRoot.getElementById('CartPopup');
      const UpcartPopupBackDrop = shadowRoot.getElementById('UpcartPopupBackDrop');
      
      if (Upcart_Popup) {
        clearInterval(checkInterval_cart);
        cart_btn.addEventListener('click', function(e) {
          if (!Upcart_Popup.classList.contains('upcartPopupShow')) {
            Upcart_Popup.classList.add('upcartPopupShow');
            CartPopup.classList.add('styles_active__');
            UpcartPopupBackDrop.classList.add('styles_active__');
          } else {
            Upcart_Popup.classList.remove('upcartPopupShow');
            CartPopup.classList.remove('styles_active__');
            UpcartPopupBackDrop.classList.remove('styles_active__');
          }
        });
      } 
    }, 500); 
  }
};
